<template>
    <b-row class="property-search-null-state m-3">
        <b-col cols="12">
            <h2>No Homes Found</h2>
        </b-col>
        <b-col
                cols="12"
                class="font-size-1-rem"
        >
            There aren't any homes that match your criteria. <br>
            Try zooming out or adjusting filters.
        </b-col>
        <b-col
                cols="12"
                class="active-filters-container"
        >
            <template v-for="(activeFilter, index) in activeFilters">
        <span
                :key="activeFilter.filterOption + index"
                class="active-filter mt-3 mr-1"
        >
          {{ activeFilter.filterValue }}
          <i
                  class="fal fa-times cursor-pointer font-size-1-rem ml-2"
                  @click="clearFilter(activeFilter)"
          />
        </span>
            </template>
        </b-col>
        <b-col
                cols="12"
                class="mt-4"
        >
            <b-button
                    class="clear-filters-btn font-size-1-rem"
                    @click="clearFilters"
            >
                Clear Filters
            </b-button>
        </b-col>
    </b-row>
</template>
<script>
    import './PropertySearchNullState.scss';
    import {CLEAR_FILTER_EVENT} from "../../GroupPropertySearchHeader/PropertySearchHeader/PropertySearchHeader";
    import {ARRAY_LIKE_OPTIONS, BEDS_OR_BATHS_OPTIONS, MIN_MAX_OPTIONS, proxyFilter} from "../../../classes/Filter";
    import get from 'lodash/get';

    export default {
        name: 'PropertySearchNullState',
        data() {
            return {
                filter: proxyFilter,
            };
        },

        computed: {
            activeFilters() {
                let activeFilters = [];
                for (const [filterOption, filterValue] of Object.entries(this.filter)) {
                    if (!filterValue || Array.isArray(filterValue) && !filterValue.length) {
                        continue;
                    }
                    switch (true) {
                        case filterOption === '_search' && !!filterValue.value:
                            activeFilters.push({
                                filterOption: filterOption,
                                filterValue: filterValue.value,
                            });
                            break;
                        case BEDS_OR_BATHS_OPTIONS.hasOwnProperty(filterOption) && !!filterValue.value:
                            activeFilters.push({
                                filterOption: filterOption,
                                filterValue: filterValue.label + ' ' + filterOption.substr(1).capitalize(),
                            });
                            break;
                        case MIN_MAX_OPTIONS.hasOwnProperty(filterOption):
                            let min = get(filterValue, 'min', null),
                                max = get(filterValue, 'max', null);
                            if (!!min.value || !!max.value) {
                                let filterLabel;
                                if (!min.value) {
                                    filterLabel = 'No Min to ' + (max.label || max.value);
                                } else {
                                    filterLabel = (min.label || min.value) +
                                        (!max.value ? '+' : ' to ' + (max.label || max.value));
                                }

                                activeFilters.push({
                                    filterOption: filterOption,
                                    filterValue: filterLabel,
                                });
                            }
                            break;
                        case ARRAY_LIKE_OPTIONS.hasOwnProperty(filterOption):
                            for (const value of filterValue) {
                                if (value === null) continue;
                                activeFilters.push({
                                    filterOption: filterOption,
                                    filterValue: typeof value === 'object'
                                        ? (value.label || filterOption)
                                        : value,
                                });
                            }
                            break;
                    }
                }
                return activeFilters;
            }
        },
        methods: {
            clearFilters() {
                this.$bus.$emit(CLEAR_FILTER_EVENT);
            },

            clearFilter(filter) {
                this.$bus.$emit(CLEAR_FILTER_EVENT, filter);
            }
        },
    };
</script>
